import FormElementMixin from '../mixins/FormElementMixin.js';

Vue.asyncComponent('ak-time-picker', {
    mixins: [FormElementMixin],
    data() {
        return {
            timeMask: [/[0-2]/,/[0-9]/,':',/[0-5]/,/[0-9]/]
        };
    },
}, 'form/controls/ak-time-picker.html');